var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25.998,
    viewBox: "0 0 20 25.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 25.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1.934-9.611a.4.4,0,0,1-.117-.283.4.4,0,0,1,.4-.4.4.4,0,0,1,.284.118L9.528-3.151V-25.6a.4.4,0,0,1,.4-.4.4.4,0,0,1,.4.4V-3.151l7.163-7.163a.4.4,0,0,1,.284-.118.4.4,0,0,1,.4.4.4.4,0,0,1-.117.283l-7.439,7.44a.989.989,0,0,1-1.39,0ZM19.6-.8H.4A.4.4,0,0,0,0-.4.4.4,0,0,0,.4,0H19.6A.4.4,0,0,0,20-.4.4.4,0,0,0,19.6-.8Z",
    fill: "#00b3ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadConfiguration);
export default __webpack_public_path__ + "static/media/loadConfiguration.dc66cf9af41461e5e07a017defbf12a4.svg";
export { ForwardRef as ReactComponent };